// Redux services
import { createConsentDecision } from 'redux/services/consentDecision'

// Local
import { RootState, TypedDispatch } from 'redux/store'

const saveConsentDetails = async (
  store: RootState,
  dispatch: TypedDispatch<RootState>,
  supporterId: string,
): Promise<void> => {
  const promises = []

  promises.push(
    dispatch(
      createConsentDecision.initiate({
        supporterId: supporterId,
        opted_in: store.order.contact.optIn,
        language: store.config.optIn.wording,
        type: 'email',
      }),
    ).unwrap(),
  )

  if (store.order.contact.optInSms) {
    promises.push(
      dispatch(
        createConsentDecision.initiate({
          supporterId: supporterId,
          opted_in: store.order.contact.optInSms,
          language: store.config.optInSms.wording,
          type: 'sms',
        }),
      ).unwrap(),
    )
  }

  await Promise.all(promises)
}

export default saveConsentDetails
